module.exports = __webpack_public_path__ + "img/179.2e56103f.jpg";